import { EventType, RunGameData } from 'data/interfaces'
import { NetherlandsPilotChallenge } from 'data/netherlands-pilot/challenges'

import august2024Teams, { August2024Team } from './teams'

export default {
  name: {
    en: 'August 2024',
    nl: 'Augustus 2024',
    pt: 'Agosto de 2024',
    zh: '2024年8月',
  },
  date: new Date('2024-08-17T08:00:00.000Z').toISOString(), // 10AM Amsterdam time
  teams: august2024Teams,
  events: [
    { type: EventType.Start, timestamp: new Date('2024-08-17T08:00:00.000Z').toISOString() },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:01:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.ComplimentALocal,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:07:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.PetsAreTheBest,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:09:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.StreetArtHunt,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:10:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.ProvincesShowdown,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:10:10.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.DutchChat,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:12:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.Grachtenhuis,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:15:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.DomTowerSnapshot,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:28:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.FindMiffy,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:38:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.TheLettersToUtrecht,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:38:10.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.LocalFlavor,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:43:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.MarketBrowsing,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:44:01.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.PublicDanceDare,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:44:05.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.StatuePose,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:44:10.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.ProvincesShowdown,
      place: 'Utrecht',
    },
    // {
    //   type: EventType.ChallengeCompleted,
    //   timestamp: new Date('2024-08-17T08:46:00.000Z').toISOString(),
    //   team: August2024Team.TeamA,
    //   challenge: NetherlandsPilotChallenge.CheersToTheDutch,
    //   place: 'Utrecht',
    // },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:54:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.Grachtenhuis,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T08:56:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.DomTowerSnapshot,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T09:02:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.FindMiffy,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T09:03:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.WindmillWonder,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T09:05:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.PublicDanceDare,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T09:05:10.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.StatuePose,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T09:29:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.TheLettersToUtrecht,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T09:37:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.PublicKaraoke,
      cursedTeam: August2024Team.TeamA,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T09:42:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.WoodenShoes,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T09:53:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.LocalFlavor,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:03:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.InsuranceLandmark,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:05:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.WoodenShoes,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:13:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.ProgrammingBirthplace,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:17:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.RoyalConnection,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:25:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.StatueSelfie,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:26:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.BullishAdventure,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:39:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.CheersToTheDutch,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T12:02:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.AlphabetCity,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T12:56:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.RepurposedHistory,
      place: 'Den Haag',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T13:00:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.JapaneseChristmas,
      place: 'Den Haag',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T13:04:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.BinnenhofBeauty,
      place: 'Den Haag',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T13:14:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.DutchMasters,
      place: 'Den Haag',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T13:19:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.VOCHeritage,
      place: 'Den Haag',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T13:22:00.000Z').toISOString(),
      team: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.WindmillWonder,
      place: 'Den Haag',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:15:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.MarketBrowsing,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:22:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.RepurposedHistory,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T11:51:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.CheersToTheDutch,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T12:21:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      cursedTeam: August2024Team.TeamA,
      challenge: NetherlandsPilotChallenge.GuessTheJob,
      place: 'Utrecht',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T12:27:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.DutchMasters,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T12:39:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.RoyalConnection,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T12:42:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.Paparazzi,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T12:47:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.Photobomb,
      place: 'Amsterdam',
    },
    {
      type: EventType.ChallengeCompleted,
      timestamp: new Date('2024-08-17T13:17:00.000Z').toISOString(),
      team: August2024Team.TeamB,
      challenge: NetherlandsPilotChallenge.TwoCitiesOneName,
      place: 'Haarlem',
    },
  ],
} as RunGameData
